import { CalculatorIcon } from 'lucide-react'
import type { CondicaoUi } from './condicao-ui'

export const calculo: CondicaoUi = {
    icone: CalculatorIcon,
    parametrosIniciais: {},
}
